/* eslint-disable react/prop-types */
/* eslint-disable no-unused-expressions */
import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import Slider from 'react-slick';
import clsx from 'clsx';
import {
  Box,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  ListItemSecondaryAction,
  Divider,
  Chip,
  Typography,
  Popover,
  IconButton,
} from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import DescriptionIcon from '@material-ui/icons/Description';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import CancelIcon from '@material-ui/icons/Cancel';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import TestingOrderIcon from 'assets/img/testing_order.svg';
import MarkAsInactiveIcon from 'assets/img/mark_in_active.svg';
import MarkAsActiveIcon from 'assets/img/mark_active.svg';
import LinkedIcon from 'assets/img/linked.svg';
import ImagePlaceholder from 'assets/img/placeholder/image_placeholder.svg';
import DocumentMenu from 'views/ProductDetail/Sections/Documents/components/Menu';
import ProductLinkageModal from '../ProductLinkageModal';
import { ReactComponent as ShipIcon } from 'assets/icons/shipping-details/ic_ship.svg';
import classes from './SidebarHeader.module.scss';

const NAV_LIST = [
  {
    icon: <DescriptionIcon />,
    text: 'Document',
    nav: 'document',
  },
  {
    icon: <ShipIcon alt='ship-icon' />,
    text: 'Shipping Detail',
    nav: 'shipping_detail',
  },
  {
    icon: <ShoppingCartIcon />,
    text: 'PO',
    nav: 'po',
  },
  {
    icon: <DeleteOutlineIcon />,
    text: 'Bin',
    nav: 'bin',
  },
];

const MENUS_ACTIVE = [
  {
    icon: <EditIcon style={{ color: '#4E5A71', fontSize: 18 }} />,
    label: 'Edit product',
    action: 'edit-product',
  },
  {
    icon: <img src={TestingOrderIcon} alt='testing-order' />,
    label: 'Testing order',
    action: 'testing-order',
  },
  {
    icon: <img src={MarkAsInactiveIcon} alt='mark-as-inactive' />,
    label: (
      <span
        style={{
          color: '#FF5555',
        }}>
        Mark as inactive
      </span>
    ),
    action: 'mark-as-inactive',
  },
];

const MENUS_INACTIVE = [
  {
    icon: <img src={MarkAsActiveIcon} alt='mark-as-active' />,
    label: 'Mark as active',
    action: 'mark-as-active',
  },
];

const SidebarContent = ({
  currentActiveNav,
  images = [],
  itemNo,
  additionItemNo,
  productName,
  productCategories = [],
  onChangeNav,
  supplier,
  productId,
  productSubCategories = [],
  buyers,
  factories,
  remark,
  relatedProducts = [],
  isActive = true,
  onOpenMarkActiveModal,
  longDescription,
  tags = [],
}) => {
  const history = useHistory();
  const buttonRef = React.createRef();

  const [currentNav, setCurrentNav] = React.useState('document');
  const [showMore, setShowMore] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [showProductLinkageModal, setShowProductLinkageModal] = React.useState(false);

  React.useEffect(() => {
    setCurrentNav(currentActiveNav);
  }, [currentActiveNav]);

  const displayProductCategories = React.useMemo(() => {
    if (productSubCategories.length) return productSubCategories;
    return productCategories;
  }, [productSubCategories, productCategories]);

  const settings = {
    dots: true,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrow: false,
    initialSlide: 0,
    customPaging: () => {
      return (
        <Box>
          <button type='button' />
        </Box>
      );
    },
  };

  const renderStatus = useCallback(() => {
    return (
      <Box display='flex' alignItems='center'>
        {isActive ? (
          <CheckCircleIcon
            style={{
              color: '#32C832',
              fontSize: 14,
            }}
          />
        ) : (
          <CancelIcon
            style={{
              color: '#FF5555',
              fontSize: 14,
            }}
          />
        )}
        <Typography
          style={{
            fontSize: 12,
            marginLeft: 4,
            color: isActive ? '#32C832' : '#FF5555',
          }}>
          {isActive ? 'Active' : 'Inactive'}
        </Typography>
      </Box>
    );
  }, [isActive]);

  const onClickMore = (event) => {
    setAnchorEl(event.currentTarget);
    setShowMore(true);
  };

  const handleCloseProductLinkage = () => {
    setShowProductLinkageModal(false);
  };

  return (
    <Box className={classes.sidebarHeader}>
      <Box display='flex' flexDirection='column'>
        <Box pt={2} width='100%' display='flex' justifyContent='space-between' alignItems='center'>
          <h3 className={classes.title}>{productName}</h3>
          <IconButton
            action={buttonRef}
            className={clsx(classes.moreBtn, { [classes.focus]: showMore })}
            onClick={onClickMore}
            focusVisibleClassName='focus-visible'
            disableRipple>
            <MoreVertIcon />
          </IconButton>
        </Box>
        {relatedProducts.length ? (
          <Box
            display='flex'
            alignItems='center'
            marginTop='8px'
            style={{
              cursor: 'pointer',
            }}
            onClick={() => setShowProductLinkageModal(true)}>
            <img src={LinkedIcon} alt='LinkedIcon' />
            <Typography
              className={
                classes.linkedText
              }>{`Linked with ${relatedProducts.length} products`}</Typography>
          </Box>
        ) : null}
      </Box>
      <Slider {...settings} className={classes.slider} width='15px' height='15px'>
        {!images.length && (
          <Box className={classes.wrapperImage}>
            <img src={ImagePlaceholder} alt={`product-placeholder`} />
          </Box>
        )}
        {images
          .filter(({ url }) => !!url)
          .map(({ url }, index) => (
            <Box className={classes.wrapperImage} key={`${index}`}>
              <img src={url} alt={`product-${index}`} />
            </Box>
          ))}
      </Slider>
      <Box>
        <List className={classes.list}>
          {NAV_LIST.map(({ text, icon, nav }) => (
            <ListItem
              key={nav}
              selected={currentNav === nav}
              button
              onClick={() => {
                onChangeNav && onChangeNav(nav);
                setCurrentNav(nav);
              }}>
              <ListItemAvatar>{icon}</ListItemAvatar>
              <ListItemText primary={text} />
              {currentNav === nav && (
                <ListItemSecondaryAction>
                  <ArrowForwardIosIcon />
                </ListItemSecondaryAction>
              )}
            </ListItem>
          ))}
        </List>
      </Box>
      <List className={classes.list__info}>
        <ListItemText primary='Item No.' secondary={itemNo} />
        <ListItemText primary='Long Description' secondary={longDescription} />
        <ListItemText primary='Additional Item No.' secondary={additionItemNo} />
        <ListItemText
          disableTypography
          primary={<span>Categories</span>}
          secondary={
            <Box>
              {displayProductCategories.map(({ label, id }, index) => (
                <Chip className={classes.chip} label={label} key={id || index} />
              ))}
            </Box>
          }
        />
        <ListItemText primary='Status' secondary={renderStatus()} />
        <ListItemText primary='Remark' secondary={remark} />
      </List>
      <Divider />
      <List className={classes.list__info}>
        <ListItemText
          primary='Supplier'
          secondary={
            <a
              href={`/supplier-manager/detail/${supplier.supplierId}`}
              target='_blank'
              rel='noopener noreferrer'>
              {supplier?.supplier?.name}
            </a>
          }
        />
        <ListItemText
          primary='Factory'
          secondary={
            <Box display='flex' flexDirection='column' mt={1} gridGap={8}>
              {factories.map(({ name, id }) => (
                <a
                  href={`/supplier-manager/factory-detail/${id}`}
                  target='_blank'
                  rel='noopener noreferrer'>
                  {name}
                </a>
              ))}
            </Box>
          }
        />
        <ListItemText primary='Buyer' secondary={buyers.map(({ name }) => name).join(', ')} />
      </List>
      <Divider />
      <List className={classes.list__info}>
        <ListItemText
          primary='Customer Tag'
          secondary={
            <Box>
              {tags.map(({ name, id }, index) => (
                <Chip className={classes.chip} label={name} key={id || index} />
              ))}
            </Box>
          }
        />
      </List>
      <Popover
        PaperProps={{ className: classes.wrapMenu }}
        disableAutoFocus
        disableEnforceFocus
        open={showMore}
        anchorEl={anchorEl}
        onClose={() => {
          setShowMore(false);
          setAnchorEl(null);
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}>
        <DocumentMenu
          menus={isActive ? MENUS_ACTIVE : MENUS_INACTIVE}
          onClickMenuItem={(action) => {
            setShowMore(false);
            setAnchorEl(null);
            if (action === 'edit-product') {
              if (productId) history.push(`/edit-product/${productId}`);
            }
            if (action === 'testing-order') {
              history.push('/product-testing/create-job');
            }
            if (action === 'mark-as-active' || action === 'mark-as-inactive') {
              onOpenMarkActiveModal(true);
            }
          }}
        />
      </Popover>

      <ProductLinkageModal
        data={relatedProducts}
        open={showProductLinkageModal}
        handleClose={handleCloseProductLinkage}
      />
    </Box>
  );
};
export default SidebarContent;
